<div
    id="character-counter"
    [class.left-placement]="placement === 'left'"
    [class.right-placement]="placement === 'right'">
    <p id="current-length">({{ text.length }}</p>
    <p id="maximum-length">/{{ maxLength }})</p>
</div>
